<template>
  <div ref="containerRef" style="margin:0;padding:0;width:100%;height:100vh; box-sizing: border-box" class="row-start">

    <div style="background-color:ghostwhite;height:100%; display: flex; flex-direction: column; box-sizing: border-box" :style="{width:leftPanelWidth + 'px'}">
      <div v-if="pdfUrl !== ''" class="row-between" style="width:100%; padding:15px 20px; box-sizing: border-box">
        <el-icon style="width:20px;height:20px;background-color:#6467F0; color:white; border-radius:50%"><ArrowLeft /></el-icon>
        <el-input-number class="page-num" v-model="page" :min="1" :max="numPages" @change="handleChange" size="small"/>
        <el-icon style="width:20px;height:20px;background-color:#6467F0; color:white; border-radius:50%" @click="dialogVisible = true"><Plus /></el-icon>
      </div>
      <el-progress v-if="pdfUrl !== '' && showProgress" :percentage="percent" stroke-width="1" color="#6467F0"></el-progress>
      <div class="row pdf-container" v-if="pdfUrl !== '' && isLoading">
        <el-button style="color: #170DA8; font-size: 18px; border:none; background-color: ghostwhite" loading>PDF文件加载中</el-button>
      </div>
      <div class="pdf-container" v-if="pdfUrl !== ''" @scroll="handlePDFScroll">
        <vue-pdf-embed :source="pdfUrl" :page="currentPage" class="pdf-page" text-layer annotation-layer  @loaded="onPdfLoaded"/>
      </div>


      <div v-if="pdfUrl === '' && firstLoad"  style="border-radius: 15px; width: 40%; margin-left:30%; margin-top: 150px">
        <div class="row" style="width: 100%;padding:20px 0px">
          <img src="https://jzxq123.cn/data/files/robot-logo.png" class="logo" style="background-color: #EFEDFE"/>
          <div style="display: flex; flex-direction: column">
          <div style="font-size:27px; font-weight: bold; margin-left:5px">智能阅读</div>
          <div style="font-size:14px; font-weight: normal; margin-left:5px; color:#909399">让阅读更加高效快捷 .</div>
          </div>
        </div>
        <el-upload class="upload-tool" drag action="/files/upload" :limit="1" accept=".pdf" :on-success="handleSuccess"
                   :before-upload="handleBeforeUpload">
          <el-icon class="el-icon--upload" style="color: #6467f0"><upload-filled /></el-icon>
          <div class="el-upload__text">
            将文件拖至此处 <em>点击上传</em>
          </div>
        </el-upload>
        <div class="row" style="width:100%; margin-top:20px">
          <input class="input-beauty" placeholder="可以添加文件url"/>
          <div class="add row"><el-icon style="font-size: 16px;"><Plus /></el-icon></div>
        </div>
        <div class="row" style="font-size:14px; width:100%; margin-top:20px; text-align: left; color:dimgray">支持PDF,文件最大支持100M，图片最大支持20M, PDF/Word最多支持1000页</div>
      </div>
    </div>

    <div class="resizer" @mousedown="startResize"></div>

    <div style="background-color:white; height:100%; display: flex; flex-direction: column; box-sizing: border-box" :style="{width: rightPanelWidth + 'px'}">

      <div class="header">
<!--        <el-button class="plain-button"><el-icon style="font-size: 16px"><Clock /></el-icon><span>历史对话</span></el-button>-->
        <el-button class="plain-button" @click="clearDialogues"><el-icon style="font-size: 16px"><ChatDotRound /></el-icon><span>新建对话</span></el-button>
        <el-button class="plain-button" @click="parse_doc"><el-icon style="font-size: 16px"><Edit /></el-icon><span>在线编辑</span></el-button>
        <el-button class="plain-button" @click="load_text"><el-icon style="font-size: 16px"><Aim /></el-icon><span>内容导读</span></el-button>
        <el-button class="plain-button" @click="docUnderstand"><el-icon style="font-size: 16px"><Aim /></el-icon><span>文档解析</span></el-button>
      </div>

      <div class="mid scroll-container" @scroll="handScroll" ref="contentRef">
        <div v-if="currentMode === '内容导读'" style="width:96%; margin-left:2%">
        <div v-for="(chapter, index) in chapters" :key="index">
          <div  style="line-height:25px; padding:15px; border-radius: 15px; margin-top: 15px; border: 1px solid #ABB2FA; font-size:14px; background-color: #E4E6FE">{{chapter}}</div>
        </div>
          <div v-if="currentChapter !== ''" style="width: 100%;margin-left:0px;margin-top: 15px; padding:0px;border-radius:15px; display: flex; flex-direction: column">
            <v-md-editor  v-model="currentChapter" mode="preview"/>
          </div>
        </div>
        <div v-if="currentMode === 'AI对话'" style="width:96%; margin-left:2%">
          <div v-for="(record, index) in dialogues" :key="index">
            <div v-if="record.role === 'user'" class="row-end" style="width: 100%; margin-top:15px; margin-left:0px">
              <div style="background-color: #6467f0; color: white; border-radius: 15px 0px 15px 15px;padding:8px 15px">{{record.content}}</div>
            </div>
            <div v-if="record.role === 'assistant'" style="width: 100%;margin-left:0px; margin-top: 15px; padding:0px;border-radius:15px; display: flex; flex-direction: column">
              <v-md-editor  v-model="record.content" mode="preview"/>
            </div>
          </div>

          <div v-if="query !== ''" class="row-end" style="width: 100%; margin-top:15px;margin-left:0px">
            <div style="background-color: #6467f0; color: white; border-radius: 15px 0px 15px 15px;padding:8px 15px">{{query}}</div>
          </div>
          <div v-if="response !== ''" style="width: 100%;margin-left:0px;margin-top: 15px; padding:0px;border-radius:15px; display: flex; flex-direction: column">
            <v-md-editor  v-model="response" mode="preview"/>
          </div>
          <div class="row" style="width: 100%; margin-top:0px;margin-left:0px; height:20px"></div>
        </div>

        <div v-if="currentMode === '在线编辑'" style="width:96%; margin-left:2%">
          <div v-if="response !== ''" style="width: 100%;margin-left:0px;margin-top: 15px; padding:0px;border-radius:15px; display: flex; flex-direction: column">
            <v-md-editor  v-model="response" mode="preview"/>
          </div>
          <div class="row" style="width: 100%; margin-top:0px;margin-left:0px; height:20px"></div>
        </div>
      </div>


      <div class="footer">
        <div class="query-box">
          <div class="row-between" style="width:100%">
            <input v-model="content" placeholder="输入要查询的问题"
                   @keydown.enter="avoidEnter" @input="handleInput"
                   class="input-box"/>
            <div v-if="sendLabel === '1'" class="row" style="margin-left:10px;height: 45px; width: 45px; border-radius: 50%; background-color: lightgray">
              <img src="/send.svg" style="width: 22px; height: 22px" @click="avoidEnter"/>
            </div>
            <div v-if="sendLabel === '2'" class="row" @click="stopGen"
                 style="margin-left:10px;height: 45px; width: 45px; border-radius: 50%; background-color:white; border:2px solid #6467F0">
              <img src="/pause.svg" style="width: 20px; height: 20px"/>
            </div>
            <div v-if="sendLabel === '3'" class="row" style="margin-left:10px;height: 45px; width: 45px; border-radius: 50%; background-color: #6467F0">
              <img src="/send.svg" style="width: 22px; height: 22px" @click="avoidEnter"/>
            </div>
          </div>
        </div>
        <div style="padding:8px; width: 100%; text-align: center; font-size: 14px; color:gray">- 内容由大模型生成，请注意甄别 -</div>
      </div>





    </div>

    <el-dialog v-model="dialogVisible" title="智能阅读" width="650" align-center style="border-radius: 15px">
      <el-upload class="upload-tool" drag action="/files/upload" :limit="1" accept=".pdf" :on-success="handleSuccess"
                 :before-upload="handleBeforeUpload">
        <el-icon class="el-icon--upload" style="color: #6467f0"><upload-filled /></el-icon>
        <div class="el-upload__text">
          将文件拖至此处 <em>点击上传</em>
        </div>
      </el-upload>
      <div class="row" style="width:100%; margin-top:15px">
        <input class="input-beauty" placeholder="此处可以添加文件url"/>
        <div class="add row"><el-icon style="font-size: 16px"><Plus /></el-icon></div>
      </div>
      <div class="row-start" style="width:100%; margin-top:15px; text-align: left; color:dimgray">文档格式：支持 PDF</div>
      <div class="row-start" style="width:100%; margin-top:15px; text-align: left; color:dimgray">文档大小：文件最大支持100M，图片最大支持20M</div>
      <div class="row-start" style="width:100%; margin-top:15px; text-align: left; color:dimgray">文档页数：PDF/Word最多支持1000页</div>
    </el-dialog>
  </div>
</template>

<script setup>

import {ref, onMounted, watch} from "vue";
import {fetchEventSource} from "@microsoft/fetch-event-source";
import 'vue-pdf-embed/dist/styles/annotationLayer.css'
import 'vue-pdf-embed/dist/styles/textLayer.css'
// import { ElMessage } from 'element-plus'
import VuePdfEmbed from 'vue-pdf-embed'
import axios from "axios";
const startX = ref(0);
const isResizing = ref(false);
const leftPanelWidth = ref(200);
const rightPanelWidth = ref(200);
const containerRef = ref(null);
const percent = ref(0);
const content = ref("");
const dialogVisible = ref(false);
const pdfUrl = ref("");
// const { doc } = useVuePdfEmbed({ source: pdfUrl })
const numPages = ref(1);
const sendLabel = ref("1");
const showProgress = ref(false);
const response = ref("");
const query = ref("");
const dialogues = ref([]);
const prompt_id = ref("");
const trigger = ref("");
const contentRef = ref(null);
const page = ref(0);
const currentPage = ref(null);
const page_image_urls = ref([]);
const selectPage = ref(false);
const chapters = ref([]);
const currentChapter = ref('');
const currentMode = ref("AI对话");
const isLoading = ref(true);
const firstLoad = ref(true);

const onPdfLoaded = () => {
  isLoading.value = false;
  console.log('PDF loaded successfully.');
}


const startResize = (event) =>{
  isResizing.value = true;
  startX.value = event.clientX;
  document.addEventListener("mousemove", doResize);
  document.addEventListener("mouseup", stopResize);
}

const doResize = (event) =>{
  if (isResizing.value){
    const newLeftWidth = leftPanelWidth.value + event.clientX - startX.value;
    const containerWidth = containerRef.value.clientWidth;
    if (newLeftWidth > 200 && newLeftWidth < containerWidth - 200){
      leftPanelWidth.value = newLeftWidth;
      rightPanelWidth.value = containerWidth - leftPanelWidth.value;
      startX.value = event.clientX;
    }
  }
}

const clearDialogues = () =>{
  dialogues.value = [];
}


const handlePDFScroll =(event)=>{
  console.log(event);
  if (selectPage.value === true) {
    selectPage.value = false;
    return;
  }
  currentPage.value = null;
}

const handleChange = (value) => {
  page.value = value;
  console.log(page.value);
  currentPage.value = page.value;
  selectPage.value = true;
}


const stopResize = () =>{
  isResizing.value = false;
  document.addEventListener("mousemove", doResize);
  document.addEventListener("mouseup", stopResize);
}


const split_screen = () =>{
  const containerWidth = containerRef.value.clientWidth - 1;
  leftPanelWidth.value = containerWidth / 2;
  rightPanelWidth.value = containerWidth / 2;
}

onMounted(async() =>{
  const containerWidth = containerRef.value.clientWidth - 1;
  if (pdfUrl.value !== ""){
    leftPanelWidth.value = containerWidth / 2;
    rightPanelWidth.value = containerWidth / 2;
  }else{
    leftPanelWidth.value = containerWidth;
    rightPanelWidth.value = 0
  }

  console.log(leftPanelWidth.value);
  console.log(rightPanelWidth.value);
})

const handleInput = () =>{
  sendLabel.value = '3';
}

const load_text = async() =>{
  const resp = await axios.get('/reader', {
        params: {
          url: pdfUrl.value,
          op: 'DocIntro'
        }
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp.data.response)
  let pages  = resp.data.response;
  chapters.value = [];
  prompt_id.value = "917229e3-5173-4421-98a6-0ae16f9a7fe3";
  trigger.value = "开始生成导读 -> "
  currentMode.value = "内容导读";
  await generateContent(pages.join('\n'));
}

const docUnderstand = async() =>{
  const resp = await axios.get('/reader', {
        params: {
          url: pdfUrl.value,
          op: 'DocIntro'
        }
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp.data.response)
  let pages  = resp.data.response;
  chapters.value = [];
  prompt_id.value = "184ede8e-4f36-4939-a9ad-4dee06edfc67";
  trigger.value = "开始进行文档结构化 -> "
  currentMode.value = "内容导读";
  for(let i = 0; i < pages.length; i += 1){
    print("=========")
    console.log(pages[i]);
    await generateContent(pages[i]);
  }

}

const handleSuccess = async(response) =>{
  isLoading.value = true;
  firstLoad.value = false;
  pdfUrl.value = '';
  split_screen();
  console.log("上传成功，服务器返回的数据：", response);
  pdfUrl.value = response.response;
  console.log("文件的 URL 是:", response);
  dialogVisible.value = false;
  const resp = await axios.get('/reader', {
        params: {
          url: pdfUrl.value,
          op: 'VL2DOC'
        }
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  page_image_urls.value = resp.data.response;
  numPages.value = page_image_urls.value.length;

}

const avoidEnter = async(event) => {
  if (event.key === "Enter") {
    event.preventDefault();
  }
  query.value = content.value;
  content.value = '';
  currentMode.value = "AI对话";
  prompt_id.value = "";
  await sendPrompt();
}

const handleBeforeUpload =()=>{
  pdfUrl.value = '';
  isLoading.value = true;
  currentPage.value = 0;
  // const maxSizeInMB = 2;  // 最大允许文件大小，单位 MB
  // const isWithinSizeLimit = file.size / 1024 / 1024 < maxSizeInMB;  // 转换为 MB 并检查
  //
  // if (!isWithinSizeLimit) {
  //   ElMessage({
  //     message: '文件大小超过2M.',
  //     type: 'warning',
  //     plain: true,
  //   })
  // }
  //
  // return isWithinSizeLimit;  // 返回 false 将取消上传
}

let ctrl = new AbortController();
const sendPrompt = async () => {
  try {
    let mess = [];
    for(let i = 0; i < dialogues.value.length; i += 1){
      mess.push(dialogues.value[i]);
    }
    mess.push({"role": "user", "content": query.value})
    await fetchEventSource('/chat2users', {
      method: "POST",
      body: JSON.stringify({
        messages: mess,
        prompt_id: prompt_id.value,
        trigger: trigger.value
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      signal: ctrl.signal,
      onopen: (resp) => {
        response.value = '';
        sendLabel.value = "2";
        if (resp.ok && resp.status === 200) {
          console.log('Connection established');
        } else {
          console.error('Failed to connect:', resp);
        }
      },
      onmessage: (message) => {
        if (message.event === ''){
          response.value += "  \r";
        }else{
          response.value += message.data;
        }
      },
      onerror: (err) => {
        console.error('Error occurred:', err);
        if (ctrl && !ctrl.signal.aborted){
          ctrl.abort();
          ctrl = new AbortController();
        }
        sendLabel.value = "1";
      },
      onclose: ()=> {
        console.log('Connection closed');
        sendLabel.value = "1";
        dialogues.value.push({
          'role': 'user',
          'content': query.value
        })
        dialogues.value.push({
          'role': 'assistant',
          'content': response.value
        })
        query.value = '';
        response.value = '';
      },
      onfinish:() => {
        console.log('Finished receiving events');
      }
    });
  } catch (err) {
    console.error('Unexpected error:', err);
  }
}




// let doc_ctrl = new AbortController();
const parse_doc = async () => {
  console.log(pdfUrl.value);
  currentMode.value = "在线编辑";
  try {
    prompt_id.value = "02daa395-a0a0-4a7a-a602-1428f9447e4a";
    await fetchEventSource('/chat2vl', {
      method: "POST",
      body: JSON.stringify({
        url: page_image_urls.value[page.value - 1],
        prompt_id: prompt_id.value,
        trigger: trigger.value
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      signal: ctrl.signal,
      onopen: (resp) => {
        response.value = '';
        sendLabel.value = "2";
        if (resp.ok && resp.status === 200) {
          console.log('Connection established');
        } else {
          console.error('Failed to connect:', resp);
        }
      },
      onmessage: (message) => {
        console.log(message.data);
        if (message.event === ''){
          response.value += "  \r";
        }else{
          response.value += message.data;
        }
      },
      onerror: (err) => {
        console.error('Error occurred:', err);
        if (ctrl && !ctrl.signal.aborted){
          ctrl.abort();
          ctrl = new AbortController();
        }
        sendLabel.value = "1";
      },
      onclose: ()=> {
        console.log('Connection closed');
        sendLabel.value = "1";
        query.value = '';
        // response.value = '';
      },
      onfinish:() => {
        console.log('Finished receiving events');
      }
    });
  } catch (err) {
    console.error('Unexpected error:', err);
  }
}

const generateContent = async (prompt) => {
  try {
    let mess = [];
    mess.push({"role": "user", "content": prompt})
    await fetchEventSource('/chat2users', {
      method: "POST",
      body: JSON.stringify({
        messages: mess,
        prompt_id: prompt_id.value,
        trigger: trigger.value
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      signal: ctrl.signal,
      onopen: (resp) => {
        currentChapter.value = '';
        sendLabel.value = "2";
        if (resp.ok && resp.status === 200) {
          console.log('Connection established');
        } else {
          console.error('Failed to connect:', resp);
        }
      },
      onmessage: (message) => {
        // console.log(message.data)
        if (message.event === ''){
          currentChapter.value += "  \r";
        }else{
          if(message.data === '@@'){
            if (currentChapter.value !== ''){
              chapters.value.push(currentChapter.value);
              currentChapter.value = '';
            }
          }else{
            currentChapter.value += message.data;
          }
        }
      },
      onerror: (err) => {
        console.error('Error occurred:', err);
        if (ctrl && !ctrl.signal.aborted){
          ctrl.abort();
          ctrl = new AbortController();
        }
        sendLabel.value = "1";
      },
      onclose: ()=> {
        console.log('Connection closed');
        sendLabel.value = "1";
        if (currentChapter.value !== '') {
          chapters.value.push(currentChapter.value);
        }
        currentChapter.value = '';
      },
      onfinish:() => {
        console.log('Finished receiving events');
      }
    });
  } catch (err) {
    console.error('Unexpected error:', err);
  }
}

const stopGen = () =>{
  if (ctrl && !ctrl.signal.aborted){
    ctrl.abort();
    ctrl = new AbortController();
  }
  sendLabel.value = "1";
}


function handScroll(event){
  const {scrollTop, scrollHeight, clientHeight} = event.target;
  if (scrollTop && scrollHeight && clientHeight && scrollTop + clientHeight >= scrollHeight){
    contentRef.value.scrollTop = scrollHeight;
  }
}

function scrollToBottom(){
  if (contentRef.value){
    contentRef.value.scrollTop = contentRef.value.scrollHeight;
  }
}

watch(response,()=>{
  scrollToBottom();
})

watch(currentChapter,()=>{
  scrollToBottom();
})




</script>

<style scoped>

.loading-indicator, .error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 5px;
  text-align: center;
}

.v-md-editor{
  border-radius: 15px;
  border: 1px solid #F2F6FC;
}
.v-md-editor:hover{
  border-radius: 15px;
  background-color: ghostwhite;
  border: 1px solid #6467f0;
}

.header, .mid, .footer{
  width:100%;
  padding:10px;
  box-sizing: border-box
}

.page-num{

}

.page-num:hover{
  --el-border-color-hover: #6467F0;
}

.page-num:focus{
  --el-input-focus-border: 1px solid #6467F0;
  border:none;
}

.footer{
  padding:0px
}

.mid{
  flex-grow: 1.0;
}

.resizer{
  width: 1px;
  height:100%;
  background-color:lightgray;
  cursor: ew-resize;
  user-select: none;
  z-index: 100;
}

.upload-tool{
  background: ghostwhite;
}

.resizer:hover{
  width: 1px;
  height:100%;
  background-color:#6467F0;
  cursor: ew-resize;
  user-select: none;
  z-index: 100;
}

.pdf-container{
  width:94%;
  margin-left:3%;
  margin-top:0px;
  flex-grow: 1.0;
  box-sizing: border-box;
  overflow:auto;
}

.pdf-page{
  width:100%;
  margin-bottom:20px;
  box-shadow: 0 0px 2px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.pdf-container::-webkit-scrollbar{
  display: none
}

.vue-pdf-embed__page {
  margin-bottom: 15px;
  /*box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);*/
}

.input-box{
  resize:none;
  overflow:hidden;
  box-sizing:border-box;
  text-indent: 10px;
  height: 40px;
  line-height:35px;
  flex-grow: 1.0;
  text-align: left;
  outline: none;
  border:0px solid lightgray;
  font-size:16px;
}

.input-beauty{
  flex-grow:1.0;
  outline:none;
  border: 0.5px solid #DCDFE6;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size:14px;
  height:40px;
  padding:5px;
  text-indent: 10px;
}

.input-beauty:hover{
  border: 1px solid #6467F0;
}


.scroll-container{
  overflow: auto;
  scrollbar-width: none;
}

.scroll-container::-webkit-scrollbar{
  display: none
}

.query-box{
  width:94%;
  margin-left:3%;
  font-size: 14px;
  border:1px solid #E6E8EB;
  padding:8px;
  border-radius: 25px;
}

.query-box:hover{
  border: 1px solid #6467F0;
}

.plain-button{
  border: none;
  padding:5px 10px;
}

.plain-button:hover{
  background-color: #EFEDFE;
  color: #6467F0;
  font-weight: normal;
  border-radius: 30px;

}

.add{
  margin-left:10px;
  background-color: white;
  height:40px;
  width:40px;
  border-radius: 50%;
  border: 0.5px solid #DCDFE6;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
}

.add:hover{
  background-color: #6467f0;
  color: white;
  border: 1px solid #6467f0;
}

</style>